import * as React from "react";
const SvgComponent = ({ strokeColor = "#90EE90", ...props }) => (
   <svg
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 128 55"
    style={{
      enableBackground: "new 0 0 128 55",
    }}
    xmlSpace="preserve"
    {...props}
  >
    <style type="text/css">
      {
        "\n\t.st0{fill:none;stroke:" + strokeColor + ";stroke-width:0.6;stroke-miterlimit:10;}\n"
      }
    </style>
    <g id="Layer_2_00000078034766437017628660000014651781136001089711_">
      <g id="Layer_4_00000012445408901645575590000007929448687252741774_">
        <g>
          <path className="st0" d="M11.8,41.8" />
          <path className="st0" d="M3.3,25.7L3.3,25.7L3.3,25.7L3.3,25.7z" />
          <path
            className="st0"
            d="M34.3,45.1c0-0.6-0.1-2.1-0.1-3c0-0.1,0-0.2,0-0.6c0-0.5-0.3-2.1-0.3-2.1c-0.6-2.8-2.3-6.7-6.1-7.9 c-3.7-1.5-7.7-1.1-10.7,0.6l-0.3,0.1c-1.8,1-2.9,2.6-3.8,4.6c0,0-0.6,1.8-0.9,4.1c0,0.1,0,0.4,0,0.4c0,0.1,0,0.2,0,0.4"
          />
          <path
            className="st0"
            d="M93.1,40.1c-1.1,0.4-1.3,2.7-1.3,2.9c0,0.1-0.1,0.8-0.1,0.8l-0.2,0.3l-55.9,0.6h-1.5h0.2l0,0"
          />
          <path
            className="st0"
            d="M125.4,23.6c0.1,0.2,0.5,1.3,0.7,1.8c0.1,0.2,0.1,3.1,0.1,3.4c-0.1,1.6-0.1,2.4-0.1,3.3c0,0-0.1,0.9,0,1 c0.1,0.5,0.2,2.4,0.2,2.4s0,0.6,0,0.9c0,0,0,0.4,0,0.5c0,0,0.2,0.2,0.2,0.4v0.1c0,0.1-0.8,0.9-0.8,0.9c-0.1,0,0,0.3,0.2,0.5 c0,0,0.4,0.4,0.4,0.5c0.1,0.2,0.3,0.6,0.2,0.8c0,0-0.2,0.3-0.2,0.5c0,0.1,0,0.1,0,0c0,0.1-0.1,0.8-0.2,0.9l-0.6,0.3l-4.1,0.6 c-0.1,0-2.9,0.3-2.9,0.3l-3.5,0.4l-0.6-1"
          />
          <path
            className="st0"
            d="M12.1,41.7c0,0.2-0.1,2.6,0,2.8c0,0-0.1,0-0.2,0c-0.2,0-0.9-0.1-0.9-0.1c-0.2,0-4.9-0.3-5.2-0.4l-1.6,0.5 l-0.6-1.1c-0.5-0.1-1.1-0.2-1.1-0.2L2.2,43L2,42.6l-0.1-0.2c-0.2-0.5-0.4-1-0.4-1.2c0-0.4,1.7-2.3,1.7-2.6c0,0-0.5-3-0.6-3.5 c0,0,0.2-3.6,0.4-6.1c0.1-1.4,0.5-2.3,1.7-3l2.2-1.1"
          />
        </g>
      </g>
      <path className="st0" d="M92.9,40.3c0-12.8,22-14.8,21.5,2" />
      <g id="Layer_2_00000155121443628905800900000004859472908403130512_">
        <ellipse className="st0" cx={103.8} cy={41.4} rx={9.5} ry={9.8} />
        <path
          className="st0"
          d="M111.1,41.4c0,4.1-3.3,7.1-7.1,7.1s-7.1-3.3-7.1-7.1s3.3-7.1,7.1-7.1C107.8,34.1,111.1,37.6,111.1,41.4z"
        />
        <path
          className="st0"
          d="M110.9,41.7c-1-0.1-2-0.2-3-0.2c-0.9-0.1-1-1.4-0.2-2c0.7-0.6,1.4-1,2.1-1.5l0.1-0.2 c-0.1-0.2-0.7-1.3-1.3-1.4c-0.1,0-0.2,0-0.2,0c-0.7,0.7-1.3,1.3-1.9,1.9c-0.7,0.7-1.9,0.1-1.9-0.7c0.1-1,0.1-2.1,0.2-3.1 c-0.2-0.2-2-0.2-2.1,0c0.1,1,0.1,2.1,0.2,3.1s-1.2,1.4-1.9,0.7c-0.8-0.8-1.3-1.3-1.9-1.9l-1.2,1.5c0,0.1,0,0.1,0,0.2 c0.6,0.5,1,0.9,1.7,1.3c0.7,0.6,0.6,1.9-0.2,2c-1,0.1-1.3,0.1-2.4,0.2l0.3,2.1c-0.1,0.1,1.2,0,2.2-0.4c0.7-0.2,1.5,0.7,1.3,1.4 c-0.5,0.9-0.6,1.3-1.2,2.1c0,0,1.2,1,1.4,1c0.1,0,0.2,0,0.2-0.1c0.2-0.9,0.6-1.5,0.9-2.7c0.2-0.9,1.6-0.9,2.1,0 c0.3,0.9,0.6,1.5,0.9,2.6c0,0,0.1,0.5,0.2,0.5c0.2,0,1.7-0.4,1.9-0.7c0.1-0.1-0.3-0.7-0.3-0.7c-0.5-0.9-0.7-1.4-1.3-2.2 c-0.2-0.7,0.2-1.5,1.3-1.4c0.9,0.2,2.7,0.5,3.7,0.7C110.7,43.6,111.1,42.2,110.9,41.7z"
        />
        <path
          className="st0"
          d="M105,41.3c0,0.6-0.5,1-1,1s-1-0.5-1-1s0.5-1,1-1C104.6,40.2,105,40.7,105,41.3z"
        />
        <circle className="st0" cx={106.2} cy={41.5} r={0.5} />
        <circle className="st0" cx={102.2} cy={40.1} r={0.5} />
        <circle className="st0" cx={104.4} cy={43.4} r={0.5} />
        <circle className="st0" cx={104.5} cy={39.2} r={0.5} />
        <circle className="st0" cx={102} cy={42.3} r={0.5} />
      </g>
      <g id="Layer_2_00000016073657216702278980000013240535702283208866_">
        <ellipse className="st0" cx={23.3} cy={41.7} rx={9.5} ry={9.8} />
        <path
          className="st0"
          d="M30.6,41.7c0,4.1-3.3,7.1-7.1,7.1s-7.1-3.3-7.1-7.1s3.3-7.1,7.1-7.1C27.3,34.4,30.6,37.9,30.6,41.7z"
        />
        <path
          className="st0"
          d="M30.4,42c-1-0.1-2-0.2-3-0.2c-0.9-0.1-1-1.4-0.2-2c0.7-0.6,1.4-1,2.1-1.5l0.1-0.2c-0.1-0.2-0.7-1.3-1.3-1.4 c-0.1,0-0.2,0-0.2,0c-0.7,0.7-1.3,1.3-1.9,1.9c-0.7,0.7-1.9,0.1-1.9-0.7c0.1-1,0.1-2.1,0.2-3.1c-0.2-0.2-2-0.2-2.1,0 c0.1,1,0.1,2.1,0.2,3.1s-1.2,1.4-1.9,0.7c-0.8-0.8-1.3-1.3-1.9-1.9l-1.2,1.5c0,0.1,0,0.1,0,0.2c0.6,0.5,1,0.9,1.7,1.3 c0.7,0.6,0.6,1.9-0.2,2c-1,0.1-1.3,0.1-2.4,0.2l0.3,2.1c-0.1,0.1,1.2,0,2.2-0.4c0.7-0.2,1.5,0.7,1.3,1.4c-0.5,0.9-0.6,1.3-1.2,2.1 c0,0,1.2,1,1.4,1c0.1,0,0.2,0,0.2-0.1c0.2-0.9,0.6-1.5,0.9-2.7c0.2-0.9,1.6-0.9,2.1,0c0.3,0.9,0.6,1.5,0.9,2.6 c0,0,0.1,0.5,0.2,0.5c0.2,0,1.7-0.4,1.9-0.7c0.1-0.1-0.3-0.7-0.3-0.7c-0.5-0.9-0.7-1.4-1.3-2.2c-0.2-0.7,0.2-1.5,1.3-1.4 c0.9,0.2,2.7,0.5,3.7,0.7C30.2,43.9,30.6,42.5,30.4,42z"
        />
        <path
          className="st0"
          d="M24.5,41.6c0,0.6-0.5,1-1,1s-1-0.5-1-1s0.5-1,1-1C24.1,40.5,24.5,41,24.5,41.6z"
        />
        <circle className="st0" cx={25.7} cy={41.8} r={0.5} />
        <circle className="st0" cx={21.7} cy={40.4} r={0.5} />
        <circle className="st0" cx={23.9} cy={43.7} r={0.5} />
        <circle className="st0" cx={24} cy={39.5} r={0.5} />
        <circle className="st0" cx={21.5} cy={42.6} r={0.5} />
      </g>
      <path className="st0" d="M9.9,25.4c0.4,3.4-5.5,6.5-7.3,6.5" />
      <path className="st0" d="M6.4,25.1c0.9-0.3,3.2-1.2,3.5,0.4" />
      <path className="st0" d="M125.8,23.6c-9.8,1.7-4.3,5.5-2.8,6.6" />
      <path className="st0" d="M27.4,27.5c6,0.3,10.8,9.1,9.6,17.3" />
      <path className="st0" d="M101.7,27c-8.4-0.4-13.8,8.6-11.9,17.3" />
      <path className="st0" d="M126,30.6c0,0.1-1.8,0.3-3.1-0.5" />
    </g>
    <g id="Layer_4">
      <path
        className="st0"
        d="M40.7,20.4h1.5c0.4,0,0.7-0.9,0.7-1.9l0,0c0-1.4-0.4-2.6-1-2.6h-1.3c-0.1,0-0.2,0.1-0.2,0.3l-0.1,0.6 c-0.2,0.9-0.2,2.1,0,2.9l0.1,0.3C40.5,20.3,40.6,20.4,40.7,20.4z"
      />
      <path className="st0" d="M41,20.3" />
      <path className="st0" d="M43.9,20.3" />
      <path
        className="st0"
        d="M42.2,20.5l0.1,1.1c0.1,0.1,0.2,0.4,0.2,0.6l-0.1,0.5c-0.1,0.2-0.2,0.4-0.4,0.4l-0.5,0.1 c-0.2,0.1-0.4,0-0.6-0.1l-0.4-0.4c-0.1-0.1-0.2-0.4-0.2-0.6l0.1-0.5c0.1-0.2,0.2-0.4,0.4-0.4v-0.7C41,20.4,41.8,20.4,42.2,20.5z"
      />
    </g>
  </svg>
);
export default SvgComponent;
